<header class="section-horizontal-paddings">
  <a routerLink="/">
    <img [src]="logo | async" alt="" />
  </a>
</header>
